import React from 'react';
import { message, Select, Spin } from 'antd';
import debounce from 'lodash/debounce';
import axios from 'axios';
const { Option } = Select;

class RemoteSearchSelect extends React.Component {
    constructor(props) {
        super(props);
        this.lastFetchId = 0;
        this.fetchRemoteData = debounce(this.fetchRemoteData, 800);
    }
    state = {
        data: [],
        value: [],
        fetching: false
    };
    componentDidMount() {
        this.fetchRemoteData('');
    }
    fetchRemoteData = (value, queryParams = '') => {
        const { url, paramName, fieldName, textName, valueName, query, pageSize, filter, } = this.props;
        this.lastFetchId += 1;
        const fetchId = this.lastFetchId;
        this.setState({ data: [], fetching: true });
        axios.get(`${url}/?${paramName}=${value || ''}${queryParams || query}&pageSize=${pageSize}`)
            .then((response) => {
                const body = response.data;
                if (fetchId !== this.lastFetchId) {
                    return;
                }
                if (body.errCode !== 0) {
                    message.info(body.errInfo);
                    return;
                }
                let data = []
              
                if (filter) {
                    const fn = eval(filter)
                    data = body.result[fieldName].filter(fn).map((item) => ({
                        text: item[textName],
                        value: item[valueName]
                    }));
                } else {
                    data = body.result[fieldName].map((item) => ({
                        text: item[textName],
                        value: item[valueName]
                    }));
                }


                this.setState({ data, fetching: false });
            });
    };

    handleChange = (value) => {
        this.setState({
            value,
            data: [],
            fetching: false
        });
    };

    render() {
        const { fetching, data } = this.state;
        const { value: initialValue } = this.props;
        return (
            <Select
                allowClear
                showSearch
                labelInValue={this.props.labelInValue}
                notFoundContent={fetching ? <Spin size="small" /> : null}
                filterOption={false}
                onSearch={this.fetchRemoteData}
                onChange={this.handleChange}
                style={{ width: '100%' }}
                {...this.props}
                value={data.length > 0 ? initialValue : undefined}
            >
                {data.map((d) => (
                    <Option key={d.value}>{d.text}</Option>
                ))}
            </Select>
        );
    }
}

export default RemoteSearchSelect;
